window.articleCollection = {
    $articleCollectionWrapper: null,
    $articles: null,
    $articlesCount: null,

    /**
     * Initialization of all Elements the Page
     */
    init: function($wrapper) {
        this.$articleCollectionWrapper = $wrapper
        this.$articles = this.$articleCollectionWrapper.querySelectorAll(".article__collection--list .cell"),
        this.$articlesCount = this.$articles.length;

        if(this.$articlesCount > 1) {
            setTimeout(function () {
                window.articleCollection.setHeightToArticleItems();
            },300);

            window.addEventListener('resize', function() {
                window.articleCollection.setHeightToArticleItems();
            });
        }

        if(this.$articleCollectionWrapper.querySelector(".teaser__collapse")) {
            setTimeout(function () {
                window.articleTeaser.init(window.articleCollection.$articles);
            },200);
        }
    },

    /**
     * Go threw every Article Item an set the Height equal of 2 Neighbor Element
     */
    setHeightToArticleItems: function() {
        /** If Count is Odd Number than -1 */
        if(window.articleCollection.$articlesCount % 2 === 1) { window.articleCollection.$articlesCount - 1; }

        /** Each every Article Item */
        for(var $i = 0; $i < window.articleCollection.$articlesCount; $i++) {
            if(($i + 1) %2 === 0) {
                var $item1BoxH = window.articleCollection.$articles[$i - 1].querySelector('.teaser__info'),
                    $item2BoxH = window.articleCollection.$articles[$i].querySelector('.teaser__info'),
                    $item1InfoH = window.articleCollection.$articles[$i - 1].querySelector('.teaser__additional'),
                    $item2InfoH = window.articleCollection.$articles[$i].querySelector('.teaser__additional');

                if(window.innerWidth > 639) {
                    window.articleCollection.removeHeight($item1BoxH, $item2BoxH);
                    window.articleCollection.removeHeight($item1InfoH, $item2InfoH);

                    if($item1BoxH && $item2BoxH) {
                        window.articleCollection.equalHeight($item1BoxH, $item2BoxH);
                    }
                    if($item1InfoH && $item2InfoH) {
                        window.articleCollection.equalHeight($item1InfoH, $item2InfoH);
                    }
                }
                else {
                    window.articleCollection.removeHeight($item1BoxH, $item2BoxH);
                    window.articleCollection.removeHeight($item1InfoH, $item2InfoH);
                }
            }
        }
    },

    /**
     * Search for Item with bigger Height and set their Height to the lower Height Element (equalHeight)
     */
    equalHeight: function($item1, $item2) {
        /** Check Heigher Element and set their Height to lower one */
        if($item1.clientHeight > $item2.clientHeight) {
            $item2.style.height = $item1.clientHeight + 'px';
        }
        else {
            $item1.style.height = $item2.clientHeight + 'px';
        }
    },

    /**
     * Set Teaserbox Style Height to Zero
     */
    removeHeight: function ($item1, $item2) {
        if($item1) {
            $item1.style.height = '';
        }
        if($item2) {
            $item2.style.height = '';
        }
    }
};
